function MapWidgetSkeleton(): JSX.Element {
  return <div className="map-container">Loading...</div>;
}

export default MapWidgetSkeleton;
